import { path } from 'ramda'

export const rulesForProgram = path(['fields', 'prequalificationRule'])
